<template>
  <div v-if="$attrs['carousel-data'] !== null" style="font-size: 18px">
    <p style="text-align: center">
      Score : <b class="primary--text">{{score}}</b>
    </p>

    <div v-show="score &&  score <= 10">
      Félicitation ! Vous privilégiez les graisses de bonne qualité. Continuez ainsi ! Il faut maintenant identifier si les quantités sont également adaptées avec la suite du parcours.
    </div>

    <div v-show="score &&  score > 10 && score <= 18">
      Votre alimentation n’est pas optimale sur la qualité des graisses, vous pouvez encore améliorer vos choix.
    </div>

    <div v-show="score &&  score > 18">
      Votre alimentation est trop riche en graisses de mauvaise qualité. Nous vous invitons à suivre les prochaines missions du parcours pour que votre alimentation soit plus bénéfique pour votre santé.
    </div>
  </div>
</template>

<script>
  import IriadeFormBlockMixin from './IriadeFormBlockMixin'

  export default {
    mixins: [IriadeFormBlockMixin],

    computed: {
      score () {
        let data = this.$attrs['carousel-data']['pagesDatas'];
        if (data.page1 && data.page2 && data.page3 && data.page4 && data.page5 && data.page6 && data.page7 && data.page8 && data.page9 && data.page10 && data.page11)
          return data.page1.question1 + data.page2.question2 + data.page3.question3 + data.page4.question4 + data.page5.question5 + data.page6.question6 + data.page7.question7 + data.page8.question8 + data.page9.question9 + data.page10.question10 + data.page11.question11;
        else
          return null;
      }
    }
  }
</script>
